import { InboxKindSuggestions } from './inbox-kind-suggestions.tsx';

export function InboxQuoteActionSuggestions({ conversationId }: { conversationId: string }) {
  return <InboxKindSuggestions conversationId={conversationId} kind="create_quote" />;
}
